export default "__VITE_ASSET__XcXq7gcw__"